import { concat } from "@ember/helper";
import { computed } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import { and, not } from "truth-helpers";
import componentForCollection from "discourse/helpers/component-for-collection";
import { i18n } from "discourse-i18n";
import SelectKitComponent, { pluginApiIdentifiers, resolveComponent, selectKitOptions } from "select-kit/components/select-kit";
import SelectKitBody from "select-kit/components/select-kit/select-kit-body";
import { isNumeric } from "select-kit/lib/input-utils";
import SingleSelectHeader from "./select-kit/single-select-header";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SingleSelect = dt7948.c(class SingleSelect extends SelectKitComponent {
  singleSelect = true;
  get selectedContent() {
    if (!isEmpty(this.value)) {
      let content;
      const value = this.selectKit.options.castInteger && isNumeric(this.value) ? Number(this.value) : this.value;
      if (this.selectKit.valueProperty) {
        content = (this.content || []).find(item => item[this.selectKit.valueProperty] === value);
        return this.selectKit.modifySelection(content || this.defaultItem(value, value));
      } else {
        return this.selectKit.modifySelection((this.content || []).filter(c => c === value));
      }
    } else {
      return this.selectKit.noneItem;
    }
  }
  static {
    dt7948.n(this.prototype, "selectedContent", [computed("value", "content.[]", "selectKit.noneItem")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#unless this.selectKit.isHidden}}\n      {{#let (resolveComponent this this.selectKit.options.headerComponent) as |HeaderComponent|}}\n        <HeaderComponent @tabindex={{this.tabindex}} @value={{this.value}} @selectedContent={{this.selectedContent}} @selectKit={{this.selectKit}} @id={{concat this.selectKit.uniqueID \"-header\"}} />\n      {{/let}}\n\n      <SelectKitBody @selectKit={{this.selectKit}} @id={{concat this.selectKit.uniqueID \"-body\"}}>\n        {{#let (resolveComponent this this.selectKit.options.filterComponent) as |FilterComponent|}}\n          <FilterComponent @selectKit={{this.selectKit}} @id={{concat this.selectKit.uniqueID \"-filter\"}} />\n        {{/let}}\n\n        {{#each this.collections as |collection|}}\n          {{#let (resolveComponent this (componentForCollection collection.identifier this.selectKit)) as |CollectionComponent|}}\n            <CollectionComponent @collection={{collection}} @selectKit={{this.selectKit}} @value={{this.value}} />\n          {{/let}}\n        {{/each}}\n\n        {{#if this.selectKit.filter}}\n          {{#if (and this.selectKit.hasNoContent (not this.selectKit.isLoading))}}\n            <span class=\"no-content\" role=\"alert\">\n              {{i18n \"select_kit.no_content\"}}\n            </span>\n          {{else}}\n            <span class=\"results-count\" role=\"alert\">\n              {{i18n \"select_kit.results_count\" count=this.mainCollection.length}}\n            </span>\n          {{/if}}\n        {{/if}}\n\n      </SelectKitBody>\n    {{/unless}}\n  ", {
      strictMode: true,
      scope: () => ({
        resolveComponent,
        concat,
        SelectKitBody,
        componentForCollection,
        and,
        not,
        i18n
      })
    }), this);
  }
}, [pluginApiIdentifiers(["single-select"]), selectKitOptions({
  headerComponent: SingleSelectHeader
}), classNames("single-select")]);
export default SingleSelect;